export default __webpack_public_path__ + "static/media/icon_apps.8077c1de.svg";